// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__RQRXD","toggleContainer":"Toggle_toggleContainer__20LF9"};